export enum ApiResponseState {
  SUCCESS = "success",
  ERROR = "error",
  PENDING = "pending",
  OK = "ok",
}

export enum HttpMethodEnum {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
  OPTIONS = "OPTIONS",
  HEAD = "HEAD",
}

export enum TimeFormat {
  TWELVE_HOUR = "12h",
  TWENTY_FOUR_HOUR = "24h",
  HOURS_ONLY = "hours-only",
  MINUTES_ONLY = "minutes-only",
  FULL = "full",
  SHORT = "short",
}

export enum UserRole {
  SUPER_ADMIN = "super-admin",
  ADMIN = "admin",
  CONTENT_CREATOR = "content-creator",
  SUB_CONTENT_CREATOR = "sub-creator",
  VIEWER = "viewer",
}

export enum ResponseCode {
  LOGIN_SUCCESS = "login_success",
  VERIFICATION_REQUIRED = "verification_required",
  ACCOUNT_PENDING_APPROVAL = "account_pending_approval",
  INVALID_CREDENTIALS = "invalid_credentials",
  OTP_SENT = "otp_sent",
  OTP_VERIFIED = "otp_verified",
  ACCOUNT_LOCKED = "account_locked",
  TWO_FACTOR_REQUIRED = "two_fa_required",
}

export enum OTPVerificationType {
  PASSWORD_RESET = "password_reset",
  ACCOUNT_VERIFICATION = "account_verification",
}
